module.exports = __webpack_public_path__ + "static/media/Uriel-signed.883487dd.png";